export default "__VITE_PUBLIC_ASSET__2e747780__"